"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), exports.GppModel = void 0;
const HeaderV1_js_1 = require("./section/HeaderV1.js"),
    Sections_js_1 = require("./section/Sections.js"),
    TcfCaV1_js_1 = require("./section/TcfCaV1.js"),
    TcfEuV2_js_1 = require("./section/TcfEuV2.js"),
    UspV1_js_1 = require("./section/UspV1.js"),
    UsNatV1_js_1 = require("./section/UsNatV1.js"),
    UsCaV1_js_1 = require("./section/UsCaV1.js"),
    UsVaV1_js_1 = require("./section/UsVaV1.js"),
    UsCoV1_js_1 = require("./section/UsCoV1.js"),
    UsUtV1_js_1 = require("./section/UsUtV1.js"),
    UsCtV1_js_1 = require("./section/UsCtV1.js"),
    InvalidFieldError_js_1 = require("./error/InvalidFieldError.js"),
    LazyDecodingError_js_1 = require("./error/LazyDecodingError.js");
class GppModel {
    constructor(s) {
        this.sections = new Map, s ? (this.encodedString = s, this.decoded = !1, this.dirty = !1) : (this.encodedString = "DBAA", this.decoded = !1, this.dirty = !1)
    }
    setFieldValue(s, e, t) {
        if (!this.decoded && null != this.encodedString && this.encodedString.length > 0) try {
            this.decode(this.encodedString)
        } catch (s) {
            throw new LazyDecodingError_js_1.LazyDecodingError(s.message)
        }
        let i = null;
        if (this.sections.has(s) ? i = this.sections.get(s) : s === TcfCaV1_js_1.TcfCaV1.NAME ? (i = new TcfCaV1_js_1.TcfCaV1, this.sections.set(TcfCaV1_js_1.TcfCaV1.NAME, i)) : s === TcfEuV2_js_1.TcfEuV2.NAME ? (i = new TcfEuV2_js_1.TcfEuV2, this.sections.set(TcfEuV2_js_1.TcfEuV2.NAME, i)) : s === UspV1_js_1.UspV1.NAME ? (i = new UspV1_js_1.UspV1, this.sections.set(UspV1_js_1.UspV1.NAME, i)) : s === UsNatV1_js_1.UsNatV1.NAME ? (i = new UsNatV1_js_1.UsNatV1, this.sections.set(UsNatV1_js_1.UsNatV1.NAME, i)) : s === UsCaV1_js_1.UsCaV1.NAME ? (i = new UsCaV1_js_1.UsCaV1, this.sections.set(UsCaV1_js_1.UsCaV1.NAME, i)) : s === UsVaV1_js_1.UsVaV1.NAME ? (i = new UsVaV1_js_1.UsVaV1, this.sections.set(UsVaV1_js_1.UsVaV1.NAME, i)) : s === UsCoV1_js_1.UsCoV1.NAME ? (i = new UsCoV1_js_1.UsCoV1, this.sections.set(UsCoV1_js_1.UsCoV1.NAME, i)) : s === UsUtV1_js_1.UsUtV1.NAME ? (i = new UsUtV1_js_1.UsUtV1, this.sections.set(UsUtV1_js_1.UsUtV1.NAME, i)) : s === UsCtV1_js_1.UsCtV1.NAME && (i = new UsCtV1_js_1.UsCtV1, this.sections.set(UsCtV1_js_1.UsCtV1.NAME, i)), !i) throw new InvalidFieldError_js_1.InvalidFieldError(s + "." + e + " not found");
        i.setFieldValue(e, t), this.dirty = !0
    }
    setFieldValueBySectionId(s, e, t) {
        this.setFieldValue(Sections_js_1.Sections.SECTION_ID_NAME_MAP.get(s), e, t)
    }
    getFieldValue(s, e) {
        if (!this.decoded && null != this.encodedString && this.encodedString.length > 0) try {
            this.decode(this.encodedString)
        } catch (s) {
            throw new LazyDecodingError_js_1.LazyDecodingError(s.message)
        }
        return this.sections.has(s) ? this.sections.get(s).getFieldValue(e) : null
    }
    getFieldValueBySectionId(s, e) {
        return this.getFieldValue(Sections_js_1.Sections.SECTION_ID_NAME_MAP.get(s), e)
    }
    hasField(s, e) {
        if (!this.decoded && null != this.encodedString && this.encodedString.length > 0) try {
            this.decode(this.encodedString)
        } catch (s) {
            throw new LazyDecodingError_js_1.LazyDecodingError(s.message)
        }
        return !!this.sections.has(s) && this.sections.get(s).hasField(e)
    }
    hasFieldBySectionId(s, e) {
        return this.hasField(Sections_js_1.Sections.SECTION_ID_NAME_MAP.get(s), e)
    }
    hasSection(s) {
        if (!this.decoded && null != this.encodedString && this.encodedString.length > 0) try {
            this.decode(this.encodedString)
        } catch (s) {
            throw new LazyDecodingError_js_1.LazyDecodingError(s.message)
        }
        return this.sections.has(s)
    }
    hasSectionId(s) {
        return this.hasSection(Sections_js_1.Sections.SECTION_ID_NAME_MAP.get(s))
    }
    deleteSection(s) {
        if (!this.decoded && null != this.encodedString && this.encodedString.length > 0) try {
            this.decode(this.encodedString)
        } catch (s) {
            throw new LazyDecodingError_js_1.LazyDecodingError(s.message)
        }
        this.sections.delete(s), this.dirty = !0
    }
    deleteSectionById(s) {
        this.deleteSection(Sections_js_1.Sections.SECTION_ID_NAME_MAP.get(s))
    }
    clear() {
        this.sections.clear(), this.encodedString = "DBAA", this.decoded = !1, this.dirty = !1
    }
    getHeader() {
        if (!this.decoded && null != this.encodedString && this.encodedString.length > 0) try {
            this.decode(this.encodedString)
        } catch (s) {
            throw new LazyDecodingError_js_1.LazyDecodingError(s.message)
        }
        let s = new HeaderV1_js_1.HeaderV1;
        return s.setFieldValue("SectionIds", this.getSectionIds()), s.toObj()
    }
    getSection(s) {
        if (!this.decoded && null != this.encodedString && this.encodedString.length > 0) try {
            this.decode(this.encodedString)
        } catch (s) {
            throw new LazyDecodingError_js_1.LazyDecodingError(s.message)
        }
        return this.sections.has(s) ? this.sections.get(s).toObj() : null
    }
    getSectionIds() {
        if (!this.decoded && null != this.encodedString && this.encodedString.length > 0) try {
            this.decode(this.encodedString)
        } catch (s) {
            throw new LazyDecodingError_js_1.LazyDecodingError(s.message)
        }
        let s = [];
        for (let e = 0; e < Sections_js_1.Sections.SECTION_ORDER.length; e++) {
            let t = Sections_js_1.Sections.SECTION_ORDER[e];
            if (this.sections.has(t)) {
                let e = this.sections.get(t);
                s.push(e.getId())
            }
        }
        return s
    }
    encode() {
        if (!this.dirty) return this.encodedString;
        if (!this.decoded && null != this.encodedString && this.encodedString.length > 0) try {
            this.decode(this.encodedString)
        } catch (s) {
            throw new LazyDecodingError_js_1.LazyDecodingError(s.message)
        }
        let s = [],
            e = [];
        for (let t = 0; t < Sections_js_1.Sections.SECTION_ORDER.length; t++) {
            let i = Sections_js_1.Sections.SECTION_ORDER[t];
            if (this.sections.has(i)) {
                let t = this.sections.get(i);
                s.push(t.encode()), e.push(t.getId())
            }
        }
        let t = new HeaderV1_js_1.HeaderV1;
        return t.setFieldValue("SectionIds", this.getSectionIds()), s.unshift(t.encode()), this.encodedString = s.join("~"), this.dirty = !1, this.encodedString
    }
    decode(s) {
        this.encodedString = s, this.decoded = !1, this.dirty = !0, this.sections.clear();
        let e = s.split("~"),
            t = new HeaderV1_js_1.HeaderV1(e[0]);
        this.sections.set(HeaderV1_js_1.HeaderV1.NAME, t);
        let i = t.getFieldValue("SectionIds");
        for (let s = 0; s < i.length; s++)
            if (i[s] === TcfCaV1_js_1.TcfCaV1.ID) {
                let t = new TcfCaV1_js_1.TcfCaV1(e[s + 1]);
                this.sections.set(TcfCaV1_js_1.TcfCaV1.NAME, t)
            } else if (i[s] === TcfEuV2_js_1.TcfEuV2.ID) {
            let t = new TcfEuV2_js_1.TcfEuV2(e[s + 1]);
            this.sections.set(TcfEuV2_js_1.TcfEuV2.NAME, t)
        } else if (i[s] === UspV1_js_1.UspV1.ID) {
            let t = new UspV1_js_1.UspV1(e[s + 1]);
            this.sections.set(UspV1_js_1.UspV1.NAME, t)
        } else if (i[s] === UsNatV1_js_1.UsNatV1.ID) {
            let t = new UsNatV1_js_1.UsNatV1(e[s + 1]);
            this.sections.set(UsNatV1_js_1.UsNatV1.NAME, t)
        } else if (i[s] === UsCaV1_js_1.UsCaV1.ID) {
            let t = new UsCaV1_js_1.UsCaV1(e[s + 1]);
            this.sections.set(UsCaV1_js_1.UsCaV1.NAME, t)
        } else if (i[s] === UsVaV1_js_1.UsVaV1.ID) {
            let t = new UsVaV1_js_1.UsVaV1(e[s + 1]);
            this.sections.set(UsVaV1_js_1.UsVaV1.NAME, t)
        } else if (i[s] === UsCoV1_js_1.UsCoV1.ID) {
            let t = new UsCoV1_js_1.UsCoV1(e[s + 1]);
            this.sections.set(UsCoV1_js_1.UsCoV1.NAME, t)
        } else if (i[s] === UsUtV1_js_1.UsUtV1.ID) {
            let t = new UsUtV1_js_1.UsUtV1(e[s + 1]);
            this.sections.set(UsUtV1_js_1.UsUtV1.NAME, t)
        } else if (i[s] === UsCtV1_js_1.UsCtV1.ID) {
            let t = new UsCtV1_js_1.UsCtV1(e[s + 1]);
            this.sections.set(UsCtV1_js_1.UsCtV1.NAME, t)
        }
        this.decoded = !0, this.dirty = !1
    }
    encodeSection(s) {
        if (!this.decoded && null != this.encodedString && this.encodedString.length > 0) try {
            this.decode(this.encodedString)
        } catch (s) {
            throw new LazyDecodingError_js_1.LazyDecodingError(s.message)
        }
        return this.sections.has(s) ? this.sections.get(s).encode() : null
    }
    encodeSectionById(s) {
        return this.encodeSection(Sections_js_1.Sections.SECTION_ID_NAME_MAP.get(s))
    }
    decodeSection(s, e) {
        if (!this.decoded && null != this.encodedString && this.encodedString.length > 0) try {
            this.decode(this.encodedString)
        } catch (s) {
            throw new LazyDecodingError_js_1.LazyDecodingError(s.message)
        }
        let t = null;
        this.sections.has(s) ? t = this.sections.get(s) : s === TcfCaV1_js_1.TcfCaV1.NAME ? (t = new TcfCaV1_js_1.TcfCaV1, this.sections.set(TcfCaV1_js_1.TcfCaV1.NAME, t)) : s === TcfEuV2_js_1.TcfEuV2.NAME ? (t = new TcfEuV2_js_1.TcfEuV2, this.sections.set(TcfEuV2_js_1.TcfEuV2.NAME, t)) : s === UspV1_js_1.UspV1.NAME ? (t = new UspV1_js_1.UspV1, this.sections.set(UspV1_js_1.UspV1.NAME, t)) : s === UsNatV1_js_1.UsNatV1.NAME ? (t = new UsNatV1_js_1.UsNatV1, this.sections.set(UsNatV1_js_1.UsNatV1.NAME, t)) : s === UsCaV1_js_1.UsCaV1.NAME ? (t = new UsCaV1_js_1.UsCaV1, this.sections.set(UsCaV1_js_1.UsCaV1.NAME, t)) : s === UsVaV1_js_1.UsVaV1.NAME ? (t = new UsVaV1_js_1.UsVaV1, this.sections.set(UsVaV1_js_1.UsVaV1.NAME, t)) : s === UsCoV1_js_1.UsCoV1.NAME ? (t = new UsCoV1_js_1.UsCoV1, this.sections.set(UsCoV1_js_1.UsCoV1.NAME, t)) : s === UsUtV1_js_1.UsUtV1.NAME ? (t = new UsUtV1_js_1.UsUtV1, this.sections.set(UsUtV1_js_1.UsUtV1.NAME, t)) : s === UsCtV1_js_1.UsCtV1.NAME && (t = new UsCtV1_js_1.UsCtV1, this.sections.set(UsCtV1_js_1.UsCtV1.NAME, t))
        
        if ( t ) {
            t.decode(e);
            console.log( " GppModel.decodeSection() - e = ", e)
            this.dirty = true;    // https://github.com/IABTechLab/iabgpp-es/pull/41/files
        }
    }
    decodeSectionById(s, e) {
        this.decodeSection(Sections_js_1.Sections.SECTION_ID_NAME_MAP.get(s), e)
    }
    toObject() {
        if (!this.decoded && null != this.encodedString && this.encodedString.length > 0) try {
            this.decode(this.encodedString)
        } catch (s) {
            throw new LazyDecodingError_js_1.LazyDecodingError(s.message)
        }
        let s = {};
        for (let e = 0; e < Sections_js_1.Sections.SECTION_ORDER.length; e++) {
            let t = Sections_js_1.Sections.SECTION_ORDER[e];
            this.sections.has(t) && (s[t] = this.sections.get(t).toObj())
        }
        return s
    }
}
exports.GppModel = GppModel;